<template>
  <div>
    <Valentine />
    <CookieBox />
  </div>
</template>

<script>

import Valentine from '@/components/valentine/Valentine.vue'
import CookieBox from '@/components/CookieBox.vue';

export default {
  name: 'valentine',
  components: {
    Valentine,
    CookieBox
  }
}
</script>
